import { MARKET_CONDITION_LABELS } from './resaleScore';
import { PUBLIC_REPORT_HOST } from './resaleReportUrl';

const MARKET_LABELS = MARKET_CONDITION_LABELS;

export function buildResaleOgMeta(report, token, baseUrl = PUBLIC_REPORT_HOST) {
  const origin = baseUrl.replace(/\/$/, '');
  const pageUrl = `${origin}/r/${token}`;
  const business = report?.business || {};
  const vehicle = [report?.brand, report?.model, report?.year].filter(Boolean).join(' ');
  const score = report?.overall_score ?? '—';
  const market =
    MARKET_LABELS[report?.market_condition] ||
    String(report?.market_condition || '').replace(/_/g, ' ');
  const workshop = business.brand_name || 'BW Station';
  const title = vehicle
    ? `${vehicle} · Score ${score} · Certified inspection`
    : `${report?.report_number || 'Inspection report'} · Score ${score}`;
  const description = [
    `Certified pre-purchase inspection by ${workshop}.`,
    `Overall score ${score}/100.`,
    market ? `Market condition: ${market}.` : null,
    report?.report_number ? `Report ${report.report_number}.` : null,
    report?.plate_number ? `Plate ${report.plate_number}.` : null,
  ]
    .filter(Boolean)
    .join(' ');
  const image = business.logo_url || `${origin}/og-image.png`;

  return {
    title,
    description,
    image,
    pageUrl,
    siteName: workshop,
  };
}

export function resaleOgMetaTags(meta) {
  const esc = (value) =>
    String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;');

  return `
    <title>${esc(meta.title)}</title>
    <meta name="description" content="${esc(meta.description)}" />
    <meta property="og:type" content="article" />
    <meta property="og:locale" content="en_US" />
    <meta property="og:site_name" content="${esc(meta.siteName)}" />
    <meta property="og:title" content="${esc(meta.title)}" />
    <meta property="og:description" content="${esc(meta.description)}" />
    <meta property="og:url" content="${esc(meta.pageUrl)}" />
    <meta property="og:image" content="${esc(meta.image)}" />
    <meta property="og:image:alt" content="${esc(meta.title)}" />
    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:title" content="${esc(meta.title)}" />
    <meta name="twitter:description" content="${esc(meta.description)}" />
    <meta name="twitter:image" content="${esc(meta.image)}" />
    <link rel="canonical" href="${esc(meta.pageUrl)}" />
  `.trim();
}
